import { RecommendationsCarousel as Carousel } from '@xing-com/crate-jobs-components-recommendations-carousel';

import { Recommendation } from './recommendation';
import type { JobRecommendationProps } from './shared';

export const RecommendationsCarousel: React.FC<JobRecommendationProps> = ({
  recommendations,
}) => (
  <Carousel itemWidthMobile="60%">
    {recommendations.map((recommendation) => {
      if (!recommendation) {
        return null;
      }

      return (
        <Recommendation
          key={recommendation.position}
          recommendation={recommendation}
        />
      );
    })}
  </Carousel>
);
